module.exports = __webpack_public_path__ + "static/media/logomark.7a6713b8.png";